const ferries = {
  ferry: "Phà", // translated 
  ferries: "Phà", // translated 
  selectOriginPort: "Chọn cổng xuất phát", // translated 
  selectDestPort: "Chọn cảng đích", // translated 
  continue: "Tiếp tục", // translated 
  viewTimetables: "Xem thời khóa biểu", // translated 
  operator: "Người vận hành", // translated 
  cabin: "Cabin", // translated 
  cabins: "Cabin", // translated 
  place: "Địa điểm", // translated 
  places: "Địa điểm", // translated 
  seat: "Ghế", // translated 
  seats: "Ghế", // translated 
  seating: "Chỗ ngồi", // translated 
  deckSpace: "Không gian sân thượng", // translated 
  compulsory: "bắt buộc", // translated 
  departure: "Sự khởi hành", // translated 
  total: "Tổng cộng", // translated 
  back: "Mặt sau", // translated 
  next: "Kế tiếp", // translated 
  duration: "Khoảng thời gian", // translated 
  return: "Trở lại", // translated 
  prebook: "Đặt trước", // translated 
  travelInfo: "Thông tin du lịch", // translated 
  book: "Sách", // translated 
  adults: "Người lớn", // translated 
  child: "Đứa trẻ", // translated 
  seniors: "Người cao tuổi", // translated 
  senior: "Người lớn tuổi", // translated 
  to: "ĐẾN", // translated 
  passenger: "Hành khách", // translated 
  details: "Chi tiết", // translated 
  currencyForTickets: "Đơn vị tiền tệ dùng để thanh toán các vé này sẽ là", // translated 
  seatsError: "Số lượng hành khách không bằng sức chứa.", // translated 
  title: "Tiêu đề", // translated 
  firstName: "Tên", // translated 
  lastName: "Họ", // translated 
  email: "E-mail", // translated 
  phone: "Điện thoại", // translated 
  dateOfBirth: "Ngày sinh", // translated 
  placeOfBirth: "Nơi sinh", // translated 
  groupLeader: "Trưởng nhóm", // translated 
  isRequired: "Cần thiết", // translated 
  charactersOnly: "Chỉ có nhân vật", // translated 
  latinCharactersAndSpacesOnly: "Chỉ ký tự Latinh và khoảng trắng", // translated 
  validEmail: "Đây không phải là email hợp lệ.", // translated 
  atLeastOneAdult: "Cần ít nhất 1 người lớn.", // translated 
  atLeastOneSenior: "Cần ít nhất 1 sinh viên năm cuối.", // translated 
  toastAlert: "Vui lòng sửa tất cả các lỗi trong các biểu mẫu bên dưới.", // translated 
  backToFerriesList: "Trở lại danh sách phà", // translated 
  bestPrice: "Giá tốt nhất", // translated 
  fastest: "Nhanh nhất", // translated 
  beforeDeparture: "Trước khi khởi hành", // translated 
  perPerson: "mỗi người", // translated 
  notAvailableForOnlineBooking: "Không hỗ trợ đặt phòng trực tuyến.", // translated 
  hurryLimitedAvailability: "Nhanh tay lên! Số lượng có hạn!", // translated 
  berth: "Bến tàu", // translated 
  berths: "Chỗ ngủ", // translated 
  sumOfSelectionNotEqualToPersons:
    "Tổng số lựa chọn của bạn không bằng số lượng hành khách.", // translated 
  attemptToBook: "Bạn đã cố gắng đặt tổng cộng...", // translated 
  seatsWhenYouHave: "chỗ ngồi khi bạn có", // translated 
  passengersTravelling: "hành khách đi du lịch", // translated 
  withReturn: "bao gồm vé khứ hồi", // translated 
  pleaseCorrectYourSelection: "Vui lòng sửa lại lựa chọn của bạn", // translated 
  pleaseSelectUpTo: "Vui lòng chọn tối đa", // translated 
  accommodationTypes: "các loại chỗ ở", // translated 
  selectionPrices: "Giá lựa chọn", // translated 
  yourCurrentTicket: "Loại vé hiện tại của bạn là", // translated 
  upgradeTo: "Nâng cấp lên", // translated 
  wouldYouLikeToUpgrade: "Bạn có muốn nâng cấp loại vé của mình không?", // translated 
  backToTicketTypes: "Trở lại các loại vé", // translated 
  originPort: "Cảng xuất xứ", // translated 
  destinationPort: "Cảng đích", // translated 
  outboundDate: "Ngày xuất kho", // translated 
  inboundDate: "Ngày đến", // translated 
  passengers: "Hành khách", // translated 
  hasReturn: "Đã trở lại", // translated 
  passportNumber: "Số hộ chiếu", // translated 
  passportExpiryDate: "Ngày hết hạn hộ chiếu", // translated 
  passportPlaceOfIssue: "Nơi cấp hộ chiếu", // translated 
  passportStartDate: "Ngày bắt đầu hiệu lực của hộ chiếu", // translated 
  cityCode: "Bộ luật thành phố", // translated 
};


export default ferries;
